import React, { useEffect, useCallback,useMemo,  useState } from 'react';
import Button from '@mui/material/Button'; 
import SettingsIcon from '@mui/icons-material/Settings';
import TextField from '@mui/material/TextField'; 
import Typography from '@mui/material/Typography'; 
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux";
import "css/generalSettings.css";
import "css/customDialog.css";
import PropTypes from 'prop-types';
import image1 from "components/photos/sidebars/colorsTypes.jpg.webp"; 
import image2 from "components/photos/sidebars/documentsType.jpg.webp"; 
import image3 from "components/photos/sidebars/languages.jpeg";  
import image4 from "components/photos/sidebars/countries.jpeg"; 
import image5 from "components/photos/sidebars/roadTypes.jpg"; 
import image6 from "components/photos/sidebars/communities.jpeg";     
import image8 from "components/photos/sidebars/codeler.jpg"; 
import image9 from "components/photos/sidebars/description.jpg"; 
import image10 from "components/photos/sidebars/treatmentype.jpeg"; 
import image11 from "components/photos/sidebars/processtype.jpeg"; 
import image12 from "components/photos/sidebars/dangerousness.jpg"; 
import image14 from "components/photos/sidebars/opttyes.jpeg"; 
import image15 from "components/photos/sidebars/payment.png"; 
import image16 from "components/photos/sidebars/status.jpeg"; 
import image17 from "components/photos/sidebars/reason.png"; 
import image18 from "components/photos/sidebars/companytypes.png"; 
import image19 from "components/photos/sidebars/mapa.png"; 
import image20 from "components/photos/sidebars/inicdentstypes.png"; 
import image21 from "components/photos/sidebars/slatypes.jpeg"; 
import image22 from "components/photos/sidebars/resolution.png"; 
import image23 from "components/photos/sidebars/products.jpeg"; 
import image24 from "components/photos/sidebars/liquids.jpg"; 
import image25 from "components/photos/sidebars/sheetstatus.png"; 
import image26 from "components/photos/sidebars/taxes.jpg";   
import image27 from "components/photos/sidebars/prices.jpeg";   
import image28 from "components/photos/sidebars/sizes.jpg";  
import image29 from "components/photos/sidebars/vehicles.jpeg"; 
import image30 from "components/photos/sidebars/units.jpeg"; 
import image31 from "components/photos/sidebars/buttons.jpg.webp";
import image32 from "components/photos/semitrailer.jpg.webp";
import image33 from "components/photos/cranemodel.jpeg";


  
const data = [
  {
  "id": 1,
  "title": "Text_Type_Languages",
  "information": "Text_Information_Type_Languages",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image3,
  "isEnabled":true
},
{
  "id": 2,
  "title": "Text_Type_Colors",
  "information": "Text_Information_Type_Colors",
  "borde":"card border-left-danger shadow h-100 py-2",
  "icon":image1,
  "isEnabled":true
},
{
  "id": 3,
  "title": "Text_Type_Roads",
  "information": "Text_Information_Type_Roads",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image5,
  "isEnabled":true
},
{
  "id": 4,
  "title": "Text_Type_Community",
  "information": "Text_Information_Type_Community",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image6,
  "isEnabled":true
},
{
  "id": 5,
  "title": "Text_Type_Locations",
  "information": "Text_Information_Type_Locations",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image4,
  "isEnabled":true
},
{
  "id": 6,
  "title": "Text_Type_Municipality",
  "information": "Text_Information_Municipality",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image19,
  "isEnabled":true
},
{
  "id": 7,
  "title": "Text_Type_Documents",
  "information": "Text_Information_Type_Documents",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image2,
  "isEnabled":true
},
{
  "id": 8,
  "title": "Text_Type_CompanyType",
  "information": "Text_Information_CompanyType",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image18,
  "isEnabled":true
},
{
  "id": 9,
  "title": "Text_Type_Incidents",
  "information": "Text_Information_Type_Incidents",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image20,
  "isEnabled":true
},
{
  "id": 10,
  "title": "Text_Type_Status",
  "information": "Text_Information_Type_Status",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image16,
  "isEnabled":true
},
{
  "id": 11,
  "title": "Text_Type_Reasons",
  "information": "Text_Information_Type_Reasons",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image17,
  "isEnabled":true
},
{
  "id": 12,
  "title": "Text_Type_Resolutions",
  "information": "Text_Information_Type_Resolutions",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image22,
  "isEnabled":true
},
{
  "id": 13,
  "title": "Text_Type_Slas",
  "information": "Text_Information_Type_Slas",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image21,
  "isEnabled":true
},
{
  "id": 14,
  "title": "Text_Type_CodeLer",
  "information": "Text_Information_Type_CodeLer",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image8,
  "isEnabled":true
},
{
  "id": 15,
  "title": "Text_Type_Description",
  "information": "Text_Information_Type_Description",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image9,
  "isEnabled":true
},
{
  "id": 16,
  "title": "Text_Type_TreatmentType",
  "information": "Text_Information_Type_TreatmentType",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image10,
  "isEnabled":true
},
{
  "id": 17,
  "title": "Text_Type_ProcessType",
  "information": "Text_Information_Type_ProcessType",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image11,
  "isEnabled":true
},
{
  "id": 18,
  "title": "Text_Type_Dangerousness",
  "information": "Text_Information_Type_Dangerousness",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image12,
  "isEnabled":true
},
{
  "id": 19,
  "title": "Text_Type_OptType",
  "information": "Text_Information_Type_OptTypes",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image14,
  "isEnabled":true
},
{
  "id": 20,
  "title": "Text_Products",
  "information": "Text_Information_Products",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image23,
  "isEnabled":true
},
{
  "id": 21,
  "title": "Text_ProductLiquid",
  "information": "Text_Information_ProductLiquid",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image24,
  "isEnabled":true
},
{
  "id": 22,
  "title": "Text_SheetStatus",
  "information": "Text_Information_SheetStatus",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image25,
  "isEnabled":true
},
{
  "id": 23,
  "title": "Text_Type_TypeofVehicles",
  "information": "Text_Information_Type_TypesOfVehicles",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image29,
  "isEnabled":true
},
{
  "id": 24,
  "title": "Text_Type_TypeofTaxes",
  "information": "Text_Information_Type_TypesOfTaxes",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image26,
  "isEnabled":true
},
{
  "id": 25,
  "title": "Text_Type_TypeofUnits",
  "information": "Text_Information_Type_TypesOfUnits",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image30,
  "isEnabled":true
},
{
  "id": 26,
  "title": "Text_Type_TypeofPrices",
  "information": "Text_Information_Type_TypesOfPrices",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image27,
  "isEnabled":true
},
{
  "id": 27,
  "title": "Text_Type_TypeofSizes",
  "information": "Text_Information_Type_TypesOfSizes",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image28,
  "isEnabled":true
},
{
  "id": 28,
  "title": "Text_Type_PaymentType",
  "information": "Text_Information_Type_PaymentType",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image15,
  "isEnabled":true
},
{
  "id": 29,
  "title": "Text_Type_ArticlesButtons",
  "information": "Text_Information_Type_ArticlesButtons",
  "borde":"card border-left-primary shadow h-100 py-2",
  "icon":image31,
  "isEnabled":true
},
{
  "id": 30,
  "title": "Text_Type_SemiTrailer",
  "information": "Text_Information_Type_SemiTrailer",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image32,
  "isEnabled":true
},
{
  "id": 31,
  "title": "Text_Type_CraneModel",
  "information": "Text_Information_Type_CraneModel",
  "borde":"card border-left-warning shadow h-100 py-2",
  "icon":image33,
  "isEnabled":true
}]

const GeneralSettings = ({ setShowPrincipalMenu,showModalGeneralSettings, setShowModalGeneralSettings, setIndexShowSettings }) => {
  const { t } = useTranslation(['listDataGeneralSettings']);
  const [inputText, setInputText] = useState("");
  const roles = useSelector((state) => state.loginUser.roles);

  data[0].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Languages'))?true:false; 
  data[1].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Colors'))?true:false; 
  data[2].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Roads'))?true:false;
  data[3].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Community'))?true:false;  
  data[4].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Locations'))?true:false;
  data[5].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Municipality'))?true:false;
  data[6].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Docuemnts'))?true:false;
  data[7].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_CompanyTypes'))?true:false;
  data[8].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Incident'))?true:false;
  data[9].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Status'))?true:false;
  data[10].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Reasons'))?true:false;
  data[11].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Resolutions'))?true:false;
  data[12].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_SlaTypes'))?true:false;
  data[13].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_CodeLers'))?true:false;
  data[14].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Desciption'))?true:false;
  data[15].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TreatmentType'))?true:false;
  data[16].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_ProcessType'))?true:false;
  data[17].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Dangerousness'))?true:false;
  data[18].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypesOpt'))?true:false;
  data[19].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Product'))?true:false;
  data[20].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_ProductLiquid'))?true:false;
  data[21].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_SheetStatus'))?true:false;
  data[22].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypeOfVehicle'))?true:false;  
  data[23].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypeOfTax'))?true:false;  
  data[24].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypeOfUnit'))?true:false;  
  data[25].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypeOfPrice'))?true:false;  
  data[26].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypeOfSize'))?true:false;  
  data[27].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_TypesOfPayment'))?true:false;  
  data[28].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_ArticleButton'))?true:false;
  data[29].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_SemiTrailerType'))?true:false;
  data[30].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_CraneModel'))?true:false;
 
  const keyPress = useCallback((e) => {
    if (e.key === 'Escape' && showModalGeneralSettings) {
      setInputText("");
      setShowPrincipalMenu(true);
      setShowModalGeneralSettings(false);
      setIndexShowSettings(0);
    }
  }, [setShowPrincipalMenu, showModalGeneralSettings, setShowModalGeneralSettings, setIndexShowSettings]);

  useEffect(() => {
    const handleKeyPress = (event) => event?.key && keyPress(event);
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [keyPress]);

  const closeAll = () => {
    setInputText("");
    setShowPrincipalMenu(true);
    setShowModalGeneralSettings(false);
    setIndexShowSettings(0);
  };

  const onSearch = (e) => setInputText(e.target.value.toLowerCase());

  const filteredData = useMemo(() => {
    const base = data.filter(d => d.isEnabled);
    if (!inputText) return base;
    return base.filter(el => t(el.title).toLowerCase().includes(inputText)); // fix del bug
  }, [inputText, t]);

  const onSelect = (id) => {
    setInputText("");
    setIndexShowSettings(id);
    setShowModalGeneralSettings(false);
  };

  if (!showModalGeneralSettings) return null;
  return (
    <div className="gs-container container-fluid">
      {/* Header */}
      <div className="gs-header" role="region" aria-label={t('Text_Settings')}>
        <h1 className="gs-title">
          <SettingsIcon style={{ fontSize: 46 }} />
          {t('Text_Settings')}
        </h1>
        <button type="button" className="email-cancel-btn" onClick={closeAll}>
          {t('Button_Back')}
        </button>
      </div>

      {/* Search */}
      <div className="gs-search">
        <TextField
          fullWidth
          id="gs-search"
          variant="outlined"
          value={inputText}
          placeholder={t('Text_Search')}
          onChange={onSearch}
          label={t('Text_Search')}
          inputProps={{ 'aria-label': t('Text_Search') }}
        />
      </div>

      {/* Grid */}
      <div className="gs-grid" role="list">
        {filteredData.map((item) => (
          <article key={item.id} className="gs-card" role="listitem" tabIndex={0} aria-label={t(item.title)}>
            <img
              className="gs-card__img"
              src={item.icon}
              alt={t(item.title)}
              loading="lazy"
            />
            <div className="gs-card__content">
              <Typography component="h2" className="gs-card__title">
                {t(item.title)}
              </Typography>
              <Typography component="p" className="gs-card__desc">
                {t(item.information)}
              </Typography>
            </div>
            <div className="gs-card__actions">
              <Button
                className="gs-btn"
                onClick={() => onSelect(item.id)}
                aria-label={`${t('Text_Select')} ${t(item.title)}`}
              >
                {t('Text_Select')}
              </Button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};
 

GeneralSettings.propTypes = {
  setShowPrincipalMenu: PropTypes.func.isRequired,
  showModalGeneralSettings: PropTypes.bool.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired,
  setIndexShowSettings: PropTypes.func.isRequired,
};

export default GeneralSettings;